// extracted by mini-css-extract-plugin
export default {"dropdownContent":"DropdownHeader_dropdownContent__D40F0","citifydLogo":"DropdownHeader_citifydLogo__Ym18N"};